import * as socketIo from 'socket.io-client';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class SocketService {
  private socket;

  public initSocket(): void {
    const schema = window.location.protocol.includes('https')
      ? 'https'
      : 'http';
    const host: string = window.location.host.replace(/\//g, '');
    const socketUrl = `${schema}://${host}`;
    if (host.includes('localhost')) {
      this.socket = socketIo.connect(`http://localhost:3990`, {
        path: '/socket.io',
      });
    } else {
      this.socket = socketIo.connect(`${socketUrl}`, {
        withCredentials: true,
        path: '/socket.io',
      });
    }
  }

  public disconnectUser(): void {
    if (!this.socket) {
      return;
    }
    this.socket.destroy();
  }

  public sendMessage(message: any): void {
    this.socket.emit('message', message);
  }

  public send(endpoint: string, message: any): void {
    this.socket.emit(endpoint, message);
  }

  public onMessage(): Observable<any> {
    return new Observable<any>((observer) => {
      this.socket.on('message', (data: any) => observer.next(data));
    });
  }

  public onSpecificMessage(message: string): Observable<any> {
    return new Observable<any>((observer) => {
      this.socket.on(message, (data: any) => observer.next(data));
    });
  }

  public onSpotPrice(): Observable<any> {
    return new Observable<any>((observer) => {
      this.socket.on('spot', (data: any) => observer.next(data));
    });
  }

  public onClientStateChanged(): Observable<any> {
    return new Observable<any>((observer) => {
      this.socket.on('clientState', (data: any) => observer.next(data));
    });
  }

  public onNewOrders(): Observable<any> {
    return new Observable<any>((observer) => {
      this.socket.on('newOrders', (data: any) => observer.next(data));
    });
  }

  public onTradeResult(): Observable<any> {
    return new Observable<any>((observer) => {
      this.socket.on('ordersMatched', (data: any) => observer.next(data));
    });
  }

  public onStateChanged(): Observable<any> {
    return new Observable<any>((observer) => {
      this.socket.on('stateChanged', (data: any) => observer.next(data));
    });
  }

  public onCurrencyPairsUpdate(): Observable<any> {
    return new Observable<any>((observer) => {
      this.socket.on('currencyPairsUpdate', (data: any) => observer.next(data));
    });
  }

  public onRemoveOrders(): Observable<any> {
    return new Observable<any>((observer) => {
      this.socket.on('removeOrders', (data: any) => observer.next(data));
    });
  }

  public onError(): Observable<any> {
    return new Observable<any>((observer) => {
      this.socket.on('error', (data: any) => observer.next(data));
    });
  }

  public onDisconnect(): Observable<any> {
    return new Observable<any>((observer) => {
      this.socket.on('disconnect', (data: any) => observer.next(data));
    });
  }

  public onEvent(event: Event): Observable<any> {
    return new Observable<Event>((observer) => {
      this.socket.on(event, (data: any) => observer.next(data));
    });
  }

  public onDisconnectEvent(): Observable<any> {
    return new Observable<any>((observer) => {
      this.socket.on('disconnectEvent', (data: any) => observer.next(data));
    });
  }
}
